import {useCallback} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import format from 'date-fns/format';
import fromUnixTime from 'date-fns/fromUnixTime';
import {ContentStatus} from '@livongo/protobuf-grpc-external-education';
import {Program as ProgramType} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/common/user/program_pb';
import {useTranslation} from 'react-i18next';
import {FieldTypes} from 'utils/page';
import Icon from 'ui/Icon';

const statuses = ContentStatus.Values;

const LessonItem = ({data, currentLessonNumber, program, onClick}) => {
    const {t} = useTranslation();
    const seconds = data.getUiAvailableAt()?.getSeconds();
    const available = seconds ? fromUnixTime(seconds) : null;
    const currentStatus = data.getStatus();
    const isAvailable =
        currentStatus === statuses.NOT_COMPLETED ||
        currentStatus === statuses.COMPLETED;
    const isCompleted = currentStatus === statuses.COMPLETED;
    const isAvailableCurrentLesson =
        isAvailable && data.getLessonNumber() === currentLessonNumber;
    const isSelectable =
        program === ProgramType.Values.PREDIABETES
            ? isAvailable
            : isCompleted || isAvailableCurrentLesson;

    const classes = classNames(
        'LessonItem',
        {'LessonItem-available': isAvailable},
        {'LessonItem-selectable': isSelectable},
        {'LessonItem-complete': isCompleted}
    );
    const onLessonClick = useCallback(() => {
        if (isSelectable) {
            onClick(data.getLessonId());
        }
    }, [data, isSelectable, onClick]);

    return (
        <button className={classes} onClick={onLessonClick}>
            <div className="LessonItem-status">
                {isAvailable ? (
                    <div className="LessonItem-check">
                        {isCompleted && <Icon name="check" size={16} />}
                    </div>
                ) : (
                    <Icon
                        className="LessonItem-future"
                        name="future-lesson"
                        size={29}
                    />
                )}
            </div>
            <div className="LessonItem-info">
                <p className="LessonItem-heading">
                    {data
                        .getTextFieldsMap()
                        .get(FieldTypes.TITLE)
                        .getTextValue()}
                </p>
                <p className="LessonItem-description">
                    {isAvailable
                        ? `${t('lesson')} ${data.getLessonNumber()}`
                        : available
                        ? `${t('availableOn')} ${format(available, 'MMMM dd')}`
                        : t('startWithLessonOne')}
                </p>
            </div>
            {isSelectable ? (
                <Icon
                    className="LessonItem-arrow"
                    name="arrow-right"
                    size={14}
                />
            ) : null}
        </button>
    );
};

LessonItem.propTypes = {
    data: PropTypes.object.isRequired,
    currentLessonNumber: PropTypes.number.isRequired,
    program: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default LessonItem;
